<template>
  <div class="filter-range">
    <div class="from">
      <span>от</span>
      <div class="input-wrap">
        <input v-model="fromMetеr" @input="onFromMeterInput()" class="form-control" type="number" step="0.01">
        <span>м<sup>2</sup></span>
      </div>
      <div class="input-wrap">
        <input v-model="fromHectare" @input="onFromHectareInput()" class="form-control" type="number" step="0.01">
        <span>Га</span>
      </div>
    </div>
    <div class="to">
      <span>до</span>
      <div class="input-wrap">
        <input v-model="toMetеr" @input="onToMeterInput()" class="form-control" type="number" step="0.01">
        <span>м<sup>2</sup></span>
      </div>
      <div class="input-wrap">
        <input v-model="toHectare" @input="onToHectareInput()" class="form-control" type="number" step="0.01">
        <span>Га</span>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'

export default {
  name: 'FilterRangeVue',
  data () {
    return {
      fromMetеr: '',
      fromHectare: '',
      toMetеr: '',
      toHectare: ''
    }
  },
  created () {
    eventBus.$on('resetRange', data => {
      this.fromMetеr = data
      this.fromHectare = data
      this.toMetеr = data
      this.toHectare = data
      this.$emit('setInput', {key: 'from', value: this.fromMetеr, noDelay: true})
      this.$emit('setInput', {key: 'to', value: this.toMetеr, noDelay: true})
    })
  },
  methods: {
    onFromMeterInput () {
      this.fromHectare = this.convetMetersToHectareMix(this.fromMetеr)
      this.$emit('setInput', {key: 'from', value: this.fromMetеr})
    },
    onFromHectareInput () {
      let val = this.convetHectareToMetersMix(this.fromHectare)
      this.fromMetеr = val
      this.$emit('setInput', {key: 'from', value: val})
    },
    onToMeterInput () {
      this.toHectare = this.convetMetersToHectareMix(this.toMetеr)
      this.$emit('setInput', {key: 'to', value: this.toMetеr})
    },
    onToHectareInput () {
      let val = this.convetHectareToMetersMix(this.toHectare)
      this.toMetеr = val
      this.$emit('setInput', {key: 'to', value: val})
    }
  }
}
</script>

<style lang="scss">
.filter-range {
  .input-wrap {
    position: relative;
    span {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      color: #545454;
    }
  }
  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    margin-top: 10px;
    input {
      font-family: 'Montserrat_B';
      width: 130px;
      height: 25px;
    }
    .input-wrap:last-child {
      margin-left: 15px;
    }
  }
  .from {
    span {
      margin-right: 8px;
    }
  }
  .to {
    span {
      margin-right: 6px;
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/main/FilterType/FilterRangeVue.vue